module.exports = __webpack_public_path__ + "4c1367bc11f3244787573d18aba482fa.pdf";